import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PlayerTicketWinsRequest } from 'src/app/model/api/api-request/player-ticket-wins-request';
import { TicketForFmtRequest } from 'src/app/model/api/api-request/ticket-for-fmt-request';
import { TicketReservationRequest } from 'src/app/model/api/api-request/ticket-reservation-request';
import { TicketOwnership } from 'src/app/model/interfaces/ticket-ownership';
import { TicketReservation } from 'src/app/model/interfaces/ticket-reservation';
import { AppConfigService } from 'src/app/services/app-config.service';
import { SVKRequest } from '../../model/api/api-request/svk-request';
import { TicketInstanceRequest } from '../../model/api/api-request/ticket-instance-request';
import { TicketSearchRequest } from '../../model/api/api-request/ticket-search-request';
import { TicketWinStatusRequest } from '../../model/api/api-request/ticket-win-status-request';
import { TicketSearchPattern } from '../../model/enums/ticket-search-pattern';
import { TicketInstance } from '../../model/interfaces/ticket-instance';
import { TicketWinStatus } from '../../model/interfaces/ticket-win-status';
import { TicketWinEvent } from '../../model/ticket-win-event';
import { ApiClient } from '../api-client/api-client';

@Injectable()
export class TicketRepository
{
    protected readonly apiClient: ApiClient;
    protected readonly  environment: AppConfigService;

    public constructor(apiClient: ApiClient,  environment: AppConfigService)
    {
        this.apiClient = apiClient;
        this.environment = environment;
    }

    public getWinStatus(ticketNumber: number, numberOfDraws: number): Observable<TicketWinStatus>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new TicketWinStatusRequest(ticketNumber, numberOfDraws, webapiBasepath);
        const winResponse = this.apiClient.get<TicketWinStatus>(request);

        return winResponse;
    }

    public getWinStatusByPlayer(): Observable<TicketWinEvent[]>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new PlayerTicketWinsRequest(webapiBasepath);
        return this.apiClient.get<TicketWinEvent[]>(request);
    }

    public getTicketInstances(ticketNumber: number): Observable<ReadonlyArray<TicketInstance>>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new TicketInstanceRequest(ticketNumber, webapiBasepath);
        return this.apiClient.get<ReadonlyArray<TicketInstance>>(request);
    }

    public getTicketsForFmt(ticketNumber: number = null, ticketLetter: string = null): Observable<TicketOwnership[]>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new TicketForFmtRequest(ticketNumber, ticketLetter, webapiBasepath);
        return this.apiClient.get(request);
    }

    // Returns an observable that resolves into a string representing the segmented key of the owner of the provided ticket.
    public getSVKByTicket(ticketNumber: number, ticketLetter: string): Observable<string>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new SVKRequest(ticketNumber, ticketLetter, webapiBasepath);
        const svk = this.apiClient.get<string>(request);

        return svk;
    }

    public searchTickets(query: string, lotteryClassId: number, searchPattern: TicketSearchPattern): Observable<ReadonlyArray<TicketInstance>>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new TicketSearchRequest(query, lotteryClassId, searchPattern, webapiBasepath);
        return this.apiClient.get<ReadonlyArray<TicketInstance>>(request);
    }

    public getTicketReservation(): Observable<TicketReservation[]>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new TicketReservationRequest(webapiBasepath);
        return this.apiClient.get(request);
    }
}
